<template>
  <div cols="12">
    <!-- Herzfrequenz (angepasst) -->
    <v-card outlined class="d-flex flex-column pa-1 rounded-xl elevation-1">
      <user-mescan-tooltip type="herzfrequenz" />
      <v-card-title class="font-weight-bold">Herzfrequenz</v-card-title>
      <v-card-subtitle>in Schlägen pro Minute (bpm)</v-card-subtitle>

      <div class="heart-rate-container">
        <!-- Neues SVG: Das Herz pulsiert, und eine EKG-Linie läuft durch das ganze SVG -->
        <!-- EKG-Linie: Angepasst, sodass sie von kurz vor (x=80) bis kurz nach (x=460) dem Herz verläuft -->
        <svg viewBox="0 0 512 512" class="heart-rate-svg">
          <!-- Hintergrund und Herz bleiben unverändert -->
          <circle style="fill: #273b7a" cx="256" cy="256" r="256" />
          <g class="pulsating-heart">
            <path
              style="fill: #121149"
              d="M297.903,508.568c113.367-18.668,201.63-111.8,212.875-227.502L401.525,171.813l-85.202,65.21
      l-8.221-8.223l-10.988,2.836l-66.974-66.974l-15.369,24.535l53.212,51.348L79.238,290.538L297.903,508.568z" />
            <path
              style="fill: #ff6262"
              d="M91.367,224.539c0-45.463,36.854-82.316,82.316-82.316S256,179.076,256,224.539
      c0-45.463,36.854-82.316,82.316-82.316s82.316,36.854,82.316,82.316C420.633,328.806,256,416.151,256,416.151
      S91.367,323.817,91.367,224.539z" />
          </g>
          <!-- Angepasste EKG-Linie -->
          <path
            stroke=""
            class="ekg-line"
            d="
          M80,256 
          L100,200 
          L120,300 
          L140,256 
          L160,256 
          L180,200 
          L200,300 
          L220,256 
          L240,256 
          L260,200 
          L280,300 
          L300,256 
          L320,256 
          L340,200 
          L360,300 
          L380,256 
          L400,256 
          L420,200 
          L440,300 
          L460,256" />
        </svg>

        <div class="heart-rate-text">
          <number :from="0" :to="response.data.heartRate.absolute.avgHeartRate" class="heart-rate-number" />
          <div class="heart-rate-unit">bpm</div>
        </div>
      </div>

      <user-mescan-data-index-scala style="width: 100%" :colors="colors" bpm :scaleData="response.rating.heartRate" weight="50" />
    </v-card>

    <!-- Trainingsbereitschaft (unverändert) -->
    <v-card outlined class="d-flex flex-column pa-1 rounded-xl elevation-1 mt-2">
      <user-mescan-tooltip type="hrv" />
      <v-card-title class="font-weight-bold">Trainingsbereitschaft</v-card-title>

      <div class="protein-icon-container">
        <svg viewBox="0 0 512 512" class="protein-icon">
          <defs>
            <clipPath id="bottle-clip">
              <path
                d="M194.515,398.222
                  h122.971
                  c13.171,0,23.847-10.676,23.847-23.847
                  v-179.86
                  c0-13.171-10.676-23.849-23.847-23.849
                  H194.515
                  c-13.172,0-23.849,10.676-23.849,23.849
                  v179.86
                  C170.667,387.546,181.343,398.222,194.515,398.222
                  z

                  M317.487,170.667
                  h-62.061
                  v227.556
                  h62.061
                  c13.171,0,23.847-10.676,23.847-23.847
                  v-179.86
                  c0-13.171-10.676-23.849-23.847-23.849
                  H317.487
                  z" />
            </clipPath>
          </defs>
          <circle fill="#c92f00" cx="256" cy="256" r="256" />
          <path
            fill="#930000"
            d="M295.419,508.978c98.182-15.176,177.924-86.14,205.855-179.484
               L308.85,137.069l-61.755,218.629
               l8.373,8.373l-77.236,27.717L295.419,508.978z" />
          <path
            fill="#273b7a"
            d="M300.889,178.855H199.111V146.03
               c0-10.625,5.37-11.997,11.997-11.997h89.786
               c6.625,0,11.995,5.37,11.995,11.997v32.825z" />
          <g clip-path="url(#bottle-clip)">
            <rect :x="bottleFillLeft" :y="fillY" :width="bottleWidth" :height="fillHeight" fill="#ffc61b" class="fill-animate" />
          </g>
          <path
            fill="none"
            stroke="white"
            stroke-width="3"
            d="M194.515,398.222
              h122.971
              c13.171,0,23.847-10.676,23.847-23.847
              v-179.86
              c0-13.171-10.676-23.849-23.847-23.849
              H194.515
              c-13.172,0-23.849,10.676-23.849,23.849
              v179.86
              C170.667,387.546,181.343,398.222,194.515,398.222
              z" />
        </svg>

        <div class="readiness-text">{{ response.data.workoutReadiness.absolute.workoutReadiness }}%</div>
      </div>

      <user-mescan-data-index-scala
        class="mt-4"
        style="width: 100%"
        :colors="colors"
        useKeys
        :scaleData="response.rating.workoutReadiness"
        weight="50" />
    </v-card>
  </div>
</template>

<script>
import UserMescanDataIndexScala from "@/views/user/components/UserMescanDataIndexScala.vue"
import UserMescanTooltip from "@/views/user/components/UserMescanTooltip.vue"

export default {
  components: {
    UserMescanDataIndexScala,
    UserMescanTooltip,
  },
  props: {
    user: Object,
    response: Object,
  },
  data() {
    return {
      colors: ["#ff4d4d", "#ff6666", "#ff9966", "#ffd900", "#66cc66", "#72ab75", "#3c8c40"],
      animateProgress: 0,
      // Koordinaten für den Füllstand der Protein-Flasche
      bottleFillLeft: 170.667,
      bottleFillRight: 341.334,
      bottleFillBottom: 398.222,
      bottleFillTop: 170.667,
    }
  },
  computed: {
    bottleWidth() {
      return this.bottleFillRight - this.bottleFillLeft
    },
    bottleHeight() {
      return this.bottleFillBottom - this.bottleFillTop
    },
    fillHeight() {
      return (this.animateProgress / 100) * this.bottleHeight
    },
    fillY() {
      return this.bottleFillBottom - this.fillHeight
    },
  },
  watch: {
    "response.data.workoutReadiness.absolute.workoutReadiness": {
      immediate: true,
      handler(val) {
        this.animateTo(val)
      },
    },
  },
  methods: {
    animateTo(target) {
      let current = 0
      const step = () => {
        if (current < target) {
          current += 1
          this.animateProgress = current
          requestAnimationFrame(step)
        }
      }
      step()
    },
  },
}
</script>

<style scoped>
.protein-icon-container {
  width: 140px;
  margin: auto;
  position: relative;
}
.protein-icon {
  width: 100%;
  height: auto;
  display: block;
}
.readiness-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.4em;
  font-weight: bold;
  color: white;
  text-shadow: 0 0 5px #000;
}

.fill-animate {
  transform-origin: bottom; /* Ankerpunkt unten */
  animation: fillAnimate 5s ease-out infinite;
}

@keyframes fillAnimate {
  0% {
    transform: scaleY(0); /* Start: leer */
  }
  50% {
    transform: scaleY(1); /* Innerhalb der ersten 20% füllt sie sich */
  }
  90% {
    transform: scaleY(1); /* 40% (2 Sekunden bei 5s Gesamt) hält der volle Füllstand */
  }
  100% {
    transform: scaleY(0); /* Letzte 40%: langsames Leeren */
  }
}

/* Herzfrequenz */
.heart-rate-container {
  position: relative;
  width: 150px;
  height: 150px;
  margin: 20px auto;
}
.heart-rate-svg {
  width: 100%;
  height: 100%;
}
.heart-rate-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, 55%);
  text-align: center;
  color: white;
}
.heart-rate-number {
  font-size: 2em;
  font-weight: bold;
  line-height: 1;
}
.heart-rate-unit {
  font-size: 0.8em;
  line-height: 1;
}

/* Pulsierendes Herz: Die Herzgruppe pulsiert (Transformationsursprung ist das Zentrum der ViewBox) */
.pulsating-heart {
  transform-origin: 256px 256px;
  animation: heartBeat 1.5s infinite;
}
@keyframes heartBeat {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.05);
  }
  50% {
    transform: scale(1);
  }
  75% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

/* EKG-Linie: Die Linie erhält einen Stroke-Dashoffset-Effekt, der sie von links nach rechts "durchlaufen" lässt */
.ekg-line {
  fill: none;
  stroke: #ffffff;
  stroke-width: 15;
  stroke-dasharray: 1200;
  stroke-dashoffset: 1200;
  animation: dash 3s linear infinite;
}
@keyframes dash {
  to {
    stroke-dashoffset: 0;
  }
}
</style>
